import { RootState } from '..';

export const selectorCart = (state: RootState) => state.cart;
